<template>
  <section
    id="checkoutReviewOrder"
    :class="[openClass, emptyCartClass, 'expandable_section', 'review-section']"
  >
    <h2
      class="expandable_header"
      @click="updateSection(sectionName)"
    >
      {{ number }}. {{ $t('checkout.payment.reviewOrder') }}
    </h2>

    <div class="expandable_content">
      <Cart @amount-update="updatePaymentFields" />

      <button
        v-if="cartHasItems"
        class="continue-button btn btn-primary"
        @click="updateSection(sectionNext)"
      >
        {{ $t('cookie.continue') }}
      </button>
    </div>
  </section>
</template>

<script>
import Cart from '../cart/cart'

export default {
  components: {
    Cart
  },

  props: ['currentsection', 'number'],

  data() {
    return {
      cartHasItems: true,
      sectionName: 'review',
      sectionNext: 'payment',
    }
  },

  computed: {
    emptyCartClass() {
      return (this.cartHasItems) ? '' : 'empty'
    },

    selected() {
      return this.currentsection == this.sectionName
    },

    openClass() {
      return (this.selected) ? 'open' : ''
    }
  },

  methods: {
    updatePaymentFields(newFields) {
      if (newFields.itemCount > 0) {
        this.cartHasItems = true
      } else {
        this.cartHasItems = false

        // Make sure this section is selected so user is notified to keep shopping
        if (this.currentsection != this.sectionName) { this.updateSection(this.sectionName) }
      }

      this.$emit('payment-fields-update', newFields)
    },

    updateSection(section) {
      this.$emit('section-update', section)
    }
  }
}
</script>
